const proyectos = {
    propios: [
        {
            imagen: "https://raw.githubusercontent.com/cerveux/csc_renders/main/src/media/screenshot/csc.jpg",
            link: "https://csc-renders.vercel.app/",
            repositorio: "https://github.com/cerveux/csc_renders",
            titulo: "CSC Renders"
        },
        {
            imagen: "https://raw.githubusercontent.com/cerveux/melirestful/main/screenshot/screenshot-1.jpg",
            link: "https://meli-restful-front.vercel.app",
            repositorio: "https://github.com/cerveux/melirestful",
            titulo: "Práctica API MELI"
        },
        {
            imagen: "https://raw.githubusercontent.com/cerveux/cotizador/main/src/assets/screenshot/Dispersion.jpg",
            link: "https://dispersion.vercel.app/",
            repositorio: "https://github.com/No-Country/C8-64-FT-MERN",
            titulo: "Proyecto C8 No-Country"
        },{
            imagen: "https://raw.githubusercontent.com/cerveux/contrata/main/src/assets/screenshot.jpg",
            link: "https://contrata.vercel.app/",
            repositorio: "https://github.com/No-Country/S6-15-M-MERN",
            titulo: "Proyecto S6 No-Country"
        }

    ],
    udemy: [
        {
            imagen: "https://raw.githubusercontent.com/cerveux/Keeper/main/screenshot/screenshot.jpg",
            link: "https://keeper-vercel.vercel.app/",
            repositorio: "https://github.com/cerveux/Keeper",
            titulo: "Keeper App"
        },
        {
            imagen: "https://raw.githubusercontent.com/cerveux/to-do-list/main/screenshots/todo%20list.jpg",
            link: "https://to-do-cerveux.onrender.com/",
            repositorio: "https://github.com/cerveux/to-do-list",
            titulo: "To do List"
        }

    ],
    oracle: [
        {
            imagen: "https://raw.githubusercontent.com/cerveux/Challenge-ONE-Sprint-01/main/imagenes/screens/challenge-1.jpg",
            link: "https://cerveux.github.io/Challenge-ONE-Sprint-01/",
            repositorio: "https://github.com/cerveux/Challenge-ONE-Sprint-01",
            titulo: "Decodificador de Texto"
        },
        {
            imagen: "https://raw.githubusercontent.com/cerveux/Challenge-ONE-Sprint-02/main/imagenes/screens/challenge-2.jpg",
            link: "https://cerveux.github.io/Challenge-ONE-Sprint-02/",
            repositorio: "https://github.com/cerveux/Challenge-ONE-Sprint-02",
            titulo: "Juego del Ahorcado"
        }
    ]
}

export default proyectos;